/**
 * Flood Fusion Anomaly marker styling (operator-cop-doctrine §3B.8 queue-anomaly
 * marker doctrine, §3A.7 context-locked palette; §2.7 / §4.4 flood picture).
 *
 * Like the ice-storm anomaly, the flood anomaly is a SCORED queue anomaly — it
 * carries an IMS Response Level, so it reuses the Response-Level palette + pulsing-dot
 * treatment (styles/responseLevel.ts, the same family as the fused-hotspot dots).
 * What distinguishes it from a fire / ice dot is the CAHS flood kind-glyph riding
 * inside the dot (#305 — `cahs:flood` via iconRegistry, see layers/anomalyMarker
 * `hazardGlyphBillboard`). Colour is never load-bearing alone: the dot is always
 * paired with the "Response Level N" badge in the queue + panel and the glyph on the map.
 *
 * This is the act-register signal that sits ON TOP of the ambient Hydrometric Gauges
 * layer — that ambient render is untouched; this is the anomaly on top.
 */

/** Badge sub-label by anomaly type — pairs with the Response Level badge. */
export function floodTypeLabel(anomalyType: string): string {
  return anomalyType === 'warning' ? 'Warning · rapid rise' : 'Watch · rising';
}
